export default {"src":"/_next/static/media/our-services-remove.8c39d99c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};